import { useDisclosure } from '@/hooks';
import { Form, InputProps } from 'antd';
import { useEffect } from 'react';
import InputSearch from '../InputSearch';
import SelectServiceReplacementModal from '../SelectServiceReplacementModal';
import { Task } from '@/core/domain/operational/Tasks/Tasks.types';
import { useTaskMutation } from '@/core/domain/operational/Tasks/Tasks.hooks';

type Props = InputProps & {
  onServiceSelect: (task: Task) => void;
  fieldNameId: string;
};

const ServicesInputSearch: React.FC<Props> = ({
  onServiceSelect,
  fieldNameId,
  ...props
}) => {
  const [modalOpened, modalAction] = useDisclosure();
  const form = Form.useFormInstance();
  const taskId = Form.useWatch(fieldNameId, form);

  const { mutateAsync: getTask, isLoading } = useTaskMutation();

  useEffect(() => {
    if (taskId) {
      getTask(taskId).then((task) =>
        form.setFieldValue('insurerName', task.description),
      );
    }
  }, [taskId]);

  return (
    <>
      <InputSearch
        {...props}
        inputProps={{ disabled: true }}
        buttonProps={{
          onClick: modalAction.open,
          loading: isLoading,
        }}
      />

      <SelectServiceReplacementModal
        open={modalOpened}
        onCancel={modalAction.toggle}
        onOk={modalAction.close}
        handlerServiceSelect={(service) => {
          onServiceSelect(service);
          modalAction.close();
        }}
      />
    </>
  );
};

export default ServicesInputSearch;
